import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import StickyCallButton from "./StickyCallButton";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <StickyCallButton />
    </div>
  );
}
